/* jshint esnext: true */

const stateController = {

	currentState: '',

	oldState: '',


	/**
	 * Set the state and perform the neccessary actions.
	 *
	 * @param {string} state The state to switch to.
	 */
	set: function( state ) {

		// console.log( 'set state', state );

		if ( !state ) {
			return false;
		}

		// Hide all modal windows when we change state.
		// Ensures we don't cover anything up.
		modals.hide();

		// Perform actions based on the current state.
		switch ( state ) {

			// Resume a paused game.
			case 'resume':

				// UnpauseGame().

				state = 'play-game';
				gameTimer.unpause();

				break;

			// Play the game.
			case 'play-game':

				if ( !game.scene.isActive( 'SceneGame' ) ) {

					// Reset the gameplay THEN start the new scenes.
					gameplay.reset();

					game.scene.start( 'SceneController' );
					game.scene.start( 'SceneGame' );

					game.scene.stop( 'SceneMenu' );

				}

				break;

			// Run the main menu.
			case 'main-menu':

				if ( !game.scene.isActive( 'SceneMenu' ) ) {

					game.scene.start( 'SceneMenu' );

					game.scene.stop( 'SceneGame' );
					game.scene.stop( 'SceneLoad' );
					game.scene.stop( 'SceneController' );

				}

				break;

			// Game over.
			case 'game-over':


		}

		// Store the state of the app.
		this.oldState = this.currentState;
		this.currentState = state;

		// If the state has not changed then don't do anything.
		if ( this.oldState === this.currentState ) {
			return false;
		}

		// Return the new state.
		return state;

	}

};